import { render, staticRenderFns } from "./ArchivePlan.vue?vue&type=template&id=9a0a1780&scoped=true"
import script from "./ArchivePlan.vue?vue&type=script&lang=js"
export * from "./ArchivePlan.vue?vue&type=script&lang=js"
import style0 from "./ArchivePlan.vue?vue&type=style&index=0&id=9a0a1780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0a1780",
  null
  
)

export default component.exports